// Base URL without the /api/v1 part
const THAWANI_BASE_URL =
  process.env.REACT_APP_THAWANI_API_URL || "https://uatcheckout.thawani.om";
const THAWANI_API_URL = `${THAWANI_BASE_URL}/api/v1`;
const THAWANI_PUBLIC_KEY = process.env.REACT_APP_THAWANI_PUBLIC_KEY;
const THAWANI_SECRET_KEY = process.env.REACT_APP_THAWANI_SECRET_KEY;

export const createPaymentSession = async (orderData) => {
  try {
    const response = await fetch(`${THAWANI_API_URL}/checkout/session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "thawani-api-key": THAWANI_SECRET_KEY,
      },
      body: JSON.stringify({
        client_reference_id: orderData.orderId,
        products: orderData.items.map((item) => ({
          name: item.product_name,
          quantity: item.quantity,
          unit_amount: Math.round(item.unit_price * 1000), // Convert to baisa
        })),
        success_url: `${window.location.origin}/order-success?session_id={session_id}`,
        cancel_url: `${window.location.origin}/checkout?canceled=true`,
        metadata: {
          order_id: orderData.orderId,
          customer_email: orderData.customerEmail,
        },
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to create payment session");
    }

    return data.data.session_id;
  } catch (error) {
    console.error("Error creating payment session:", error);
    throw error;
  }
};

export const verifyPayment = async (sessionId) => {
  try {
    const response = await fetch(
      `${THAWANI_API_URL}/checkout/session/${sessionId}`,
      {
        headers: {
          "thawani-api-key": THAWANI_SECRET_KEY,
        },
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to verify payment");
    }

    return data.data;
  } catch (error) {
    console.error("Error verifying payment:", error);
    throw error;
  }
};

export const getPaymentUrl = (sessionId) => {
  return `${THAWANI_BASE_URL}/pay/${sessionId}?key=${THAWANI_PUBLIC_KEY}`;
};
